import { HomeScreen } from "@/features/home";

export default function HomeTab() {
  return <HomeScreen />;
}
